import { render } from "./HeaderAntrian.vue?vue&type=template&id=75d8883c"
import script from "./HeaderAntrian.vue?vue&type=script&lang=js"
export * from "./HeaderAntrian.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__